import React, { useState, ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import { Swiper as SwiperClass } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface CarouselProps {
    children: ReactNode;
    settings?: SwiperOptions;
    withArrows?: boolean;
    withNav?: boolean;
    className?: string;
}

const Carousel: React.FC<CarouselProps> = ({
                                               children,
                                               settings,
                                               withArrows = false,
                                               withNav = false,
                                               className = "",
                                           }) => {
    const [prevEl, setPrevEl] = useState<HTMLButtonElement | null>(null);
    const [nextEl, setNextEl] = useState<HTMLButtonElement | null>(null);
    const [paginationEl, setPaginationEl] = useState<HTMLDivElement | null>(null);

    const [isLocked, setIsLocked] = useState(true);

    const handleLockStatus = (swiper: SwiperClass) => {
        setIsLocked(swiper.isLocked);
    };

    return (
        <div className={`generic-carousel-wrapper ${isLocked ? 'is-locked' : ''} ${className}`}>
            <Swiper
                modules={[Navigation, Pagination]}
                watchOverflow={true}

                navigation={withArrows && prevEl && nextEl ? { prevEl, nextEl } : false}
                pagination={withNav && paginationEl ? { el: paginationEl, clickable: true } : false}

                onInit={handleLockStatus}
                onResize={handleLockStatus}
                onLock={handleLockStatus}
                onUnlock={handleLockStatus}

                {...settings}
                spaceBetween={settings?.spaceBetween ?? 24}
                slidesPerView={settings?.slidesPerView ?? 1.2}

                className="carousel-inner"
            >
                {React.Children.map(children, (child, index) => (
                    <SwiperSlide key={index}>
                        {child}
                    </SwiperSlide>
                ))}
            </Swiper>

            {!isLocked && (withArrows || withNav) && (
                <div className="carousel-controls">
                    {withNav && (
                        <div ref={(node) => setPaginationEl(node)} className="custom-dots" />
                    )}

                    {withArrows && (
                        <div className="custom-nav">
                            <button ref={(node) => setPrevEl(node)} className="nav-btn prev">
                                <svg viewBox="0 0 6 11" fill="none" stroke="currentColor"><path d="M5.5 10.5L0.5 5.5L5.5 0.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            </button>
                            <button ref={(node) => setNextEl(node)} className="nav-btn next">
                                <svg viewBox="0 0 6 11" fill="none" stroke="currentColor"><path d="M0.5 10.5L5.5 5.5L0.5 0.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Carousel;